'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

var SvgChevronUp = function (props, ref) { return (jsxRuntime.jsx("svg", _tslib.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: jsxRuntime.jsx("path", { d: "M12.807 6.955a1.155 1.155 0 0 0-.271.12c-.077.048-1.999 1.949-4.271 4.225-2.936 2.94-4.158 4.191-4.224 4.322-.187.374-.096.73.279 1.095.324.315.66.403 1.004.261.109-.046 1.271-1.18 3.916-3.823L13 9.396l3.76 3.759c2.645 2.643 3.807 3.777 3.916 3.823.337.139.73.027 1.039-.297.328-.345.406-.688.241-1.056-.066-.147-1.001-1.099-4.281-4.363-2.308-2.296-4.252-4.202-4.321-4.236a.875.875 0 0 0-.547-.071", fillRule: "evenodd", fill: "currentColor" }) }))); };
var ForwardRef = React.forwardRef(SvgChevronUp);

exports["default"] = ForwardRef;
//# sourceMappingURL=ChevronUp.js.map
